import { render, staticRenderFns } from "./MyGame.vue?vue&type=template&id=0f2a1a3b&scoped=true"
import script from "./MyGame.vue?vue&type=script&lang=js"
export * from "./MyGame.vue?vue&type=script&lang=js"
import style0 from "./MyGame.vue?vue&type=style&index=0&id=0f2a1a3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2a1a3b",
  null
  
)

export default component.exports